// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ogGd9Nf9D7812l {
  display: flex;
  height: 100vh;
}
.qQkH3a2Y2_i2LH {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  height: 100vh;
  padding: var(--ds-space-0, 0) 112px 56px 56px;
  overflow-y: scroll;
}
.cKUXy22nTK44xX {
  position: fixed;
  z-index: 10;
  top: var(--ds-space-200, 16px);
  right: var(--ds-space-400, 32px);
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
}
.ogGd9Nf9D7812l.YD1DiQxCeNErZ6,
.ogGd9Nf9D7812l.YD1DiQxCeNErZ6 .qQkH3a2Y2_i2LH,
.ogGd9Nf9D7812l.YD1DiQxCeNErZ6 .SaqT53jmoLG4tA {
  height: calc(100vh - 60px);
}
.ogGd9Nf9D7812l.YD1DiQxCeNErZ6 .cKUXy22nTK44xX {
  top: 76px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ogGd9Nf9D7812l`,
	"main": `qQkH3a2Y2_i2LH`,
	"closeButton": `cKUXy22nTK44xX`,
	"anonymous": `YD1DiQxCeNErZ6`,
	"sidebar": `SaqT53jmoLG4tA`
};
export default ___CSS_LOADER_EXPORT___;
